/* Manaseer Dates — shared behaviour. Everything here is an enhancement:
   without JavaScript the page is complete and "Add to cart" goes to the cart page as before. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;

  /* ---------- header shadow once the page scrolls ---------- */
  var bar = d.getElementById('topbar');
  if (bar) {
    var onScroll = function () { bar.classList.toggle('stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- reveal on scroll (hidden only when this script runs) ---------- */
  var rv = d.querySelectorAll('.rv');
  if ('IntersectionObserver' in window && rv.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    html.classList.add('rv-on');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rv.forEach(function (el) { io.observe(el); });
    /* safety: never leave anything hidden */
    setTimeout(function () { rv.forEach(function (el) { el.classList.add('in-view'); }); }, 4000);
  }

  /* ---------- sticky order bar on phones ---------- */
  var ob = d.getElementById('order-bar'), hero = d.getElementById('top'), buy = d.getElementById('product');
  if (ob && hero && buy && 'IntersectionObserver' in window) {
    var heroIn = true, buyIn = false;
    var show = function () { ob.hidden = heroIn || buyIn; };
    new IntersectionObserver(function (e) { heroIn = e[0].isIntersecting; show(); }, { rootMargin: '-140px 0px 0px 0px' }).observe(hero);
    new IntersectionObserver(function (e) { buyIn = e[0].isIntersecting; show(); }).observe(buy);
  }

  /* ---------- cart drawer ---------- */
  if (!window.fetch) return;
  var SEC = 'm-cart-drawer';
  var lastFocus = null;
  function drawer() { return d.getElementById('cart-drawer'); }
  function setCount(n) {
    d.querySelectorAll('.cart-count').forEach(function (c) { c.textContent = n; c.classList.toggle('zero', +n === 0); });
  }
  function openDrawer() {
    var dr = drawer(); if (!dr) return false;
    lastFocus = d.activeElement;
    dr.hidden = false;
    requestAnimationFrame(function () { dr.classList.add('open'); });
    html.classList.add('cd-lock');
    var p = dr.querySelector('.cd-panel'); if (p) p.focus({ preventScroll: true });
    return true;
  }
  function closeDrawer() {
    var dr = drawer(); if (!dr || dr.hidden) return;
    dr.classList.remove('open'); html.classList.remove('cd-lock');
    setTimeout(function () { if (!dr.classList.contains('open')) dr.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function swap(sectionsHtml) {
    var h = sectionsHtml && sectionsHtml[SEC]; if (!h) return false;
    var tmp = d.createElement('div'); tmp.innerHTML = h;
    var fresh = tmp.querySelector('#cart-drawer'), cur = drawer();
    if (!fresh || !cur) return false;
    var wasOpen = cur.classList.contains('open');
    cur.innerHTML = fresh.innerHTML;
    setCount(fresh.getAttribute('data-count') || 0);
    if (wasOpen) { cur.hidden = false; cur.classList.add('open'); }
    return true;
  }
  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SEC, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(swap);
  }

  /* open from the header cart button (the cart page itself stays a normal link) */
  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var op = t.closest('[data-cart-open]');
    if (op && !d.body.classList.contains('template-cart') && drawer()) {
      e.preventDefault(); refresh().catch(function () {}); openDrawer(); return;
    }
    if (t.closest('[data-cd-close]')) {
      var a = t.closest('a[data-cd-close]'); closeDrawer();
      if (!a) e.preventDefault();
      return;
    }
    var ln = t.closest('[data-cd-line]');
    if (ln) {
      e.preventDefault();
      var dr = drawer(); if (dr) dr.classList.add('busy');
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: +ln.getAttribute('data-cd-line'), quantity: Math.max(0, +ln.getAttribute('data-cd-qty')), sections: SEC, sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); })
        .then(function (j) { if (!swap(j.sections)) return refresh(); })
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { var x = drawer(); if (x) x.classList.remove('busy'); });
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* "Add to cart" without leaving the page */
  var form = d.getElementById('m-form');
  if (form && drawer()) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'), msg = d.querySelector('[data-o=msg]');
      if (btn) btn.classList.add('busy');
      var fd = new FormData(form);
      fd.append('sections', SEC); fd.append('sections_url', window.location.pathname);
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (msg) { msg.textContent = res.j.description || res.j.message || ''; msg.hidden = !msg.textContent; }
            return;
          }
          return (swap(res.j.sections) ? Promise.resolve() : refresh()).then(openDrawer);
        })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.classList.remove('busy'); });
    });
  }
})();
